import { render, staticRenderFns } from "./MarketTargeting.vue?vue&type=template&id=2605329c&"
import script from "./MarketTargeting.vue?vue&type=script&lang=js&"
export * from "./MarketTargeting.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports